/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {IconProps} from '../../types/types';
import useIconDLS from '../useIconDLS';

/*
 * Defines the Design Language System (DLS) Vision Camera Outlined Icon component.
 */
export const VisionCameraOutlinedIcon = (props: IconProps) => {
  const {iconSize, iconColor} = useIconDLS(props);
  return (
    <svg width='25' height='16' viewBox='0 0 24 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M9.7124 7.7373L8.46729 8.8252V6.65918L9.7124 7.7373Z' stroke={iconColor} strokeWidth='3' />
      <path d='M22.7499 13.75V1.75H21.3151L17.0107 6.25V7.75V9.25L21.3151 13.75H22.7499Z' stroke={iconColor} strokeWidth='1.5' />
      <path d='M0.75 12.75C0.75 13.8546 1.64543 14.75 2.75 14.75H15.0109C16.1154 14.75 17.0109 13.8546 17.0109 12.75V2.75C17.0109 1.64543 16.1154 0.75 15.0109 0.75H2.75C1.64543 0.75 0.75 1.64543 0.75 2.75V12.75Z' stroke={iconColor} strokeWidth='1.5' />
    </svg>
  );
};

export default VisionCameraOutlinedIcon;
